import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import type { SupportedLanguage } from '@/lib/utils/localization/getSupportedLanguages'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  country: SupportedAlpha2CountryCode
  language: SupportedLanguage
  refID: string
}

type HydraGetReferralCodeResponse = {
  items?: Array<{
    humanName: {
      firstName: string
      lastName: string
      fullName: string
      'fullName@en': string
    }
    mainAddress: {
      country: string
    }
    unicity: number
    market: string
    href: string
    customerSite: {
      href: string
    }
    id: {
      unicity: string
    }
    profilePicture: {
      href: string
    }
    businessEntity: {
      companyName: string
      legalType: string
    }
    joinDate: string
    status: string
    type: string
    entryPeriod: string
    subscriptions: Array<{
      type: string
      startDate: string
      endDate: string
    }>
    preferredName: {
      firstName: string
      lastName: string
    }
  }>
}

export const HydraGetReferralCode = async ({
  country,
  language,
  refID,
}: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/customers?referralCode=${refID}&expand=customer,preferredName`,
    headers: {
      'Accept-Language': `${language}-${country}`,
    },
    withAuth: false,
  }

  return httpTools.sendRequest<HydraGetReferralCodeResponse>(request)
}
